





import {
  defineComponent,
  onMounted,
  ComponentInternalInstance,
  getCurrentInstance,
  ref,
  watch,
} from '@vue/composition-api';
export default defineComponent({
  props: {
    accordion: {
      type: Boolean,
      default: false,
    },
    // 默认展开哪个collapse
    value: {
      type: [Array, String, Number],
      default: [],
    },
  },
  provide() {
    return {
      collapse: this,
    };
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance | null = getCurrentInstance();
    const collapse: any = (currComponent as ComponentInternalInstance).proxy;
    const activeNames: any = ref(props.value);
    const methods = {
      handleItemClick(val: any) {
        if (props.accordion) {
          activeNames.value = val;
        } else {
          const activeValues = activeNames.value;
          const index = activeValues.indexOf(val);
          if (index > -1) {
            activeValues.splice(index, 1);
          } else {
            activeValues.push(val);
          }
          activeNames.value = activeValues;
        }
      },
    };
    onMounted(() => {
      collapse.$on('menu-item-click', methods.handleItemClick);
    });
    watch(
      () => props.value,
      (val: any) => {
        if (val === (activeNames.value as any)[0]) return;
        activeNames.value = props.accordion ? val[0] : [].concat(val);
      },
    );
    return {
      activeNames,
    };
  },
});
